import { DropdownOption } from '@ntv360/component-pantry';

/**
 * Generates an array of dropdown options for years, counting down from the current year
 * to the specified oldest year.
 *
 * @param oldestYear - The oldest year to include in the list.
 * @returns An array of DropdownOption representing the years.
 */
export function generateYearOptions(oldestYear: number): DropdownOption[] {
    const current = new Date().getFullYear();
    const options: DropdownOption[] = [];
    for (let y = current; y >= oldestYear; y--) {
        options.push({ label: String(y), value: y });
    }
    return options;
}
